module.exports = __webpack_public_path__ + "static/ricardas-a2631563895a57ede23a063a4eaf299c.png";